import classNames from 'classnames';
import React from 'react';
import { Button, makeStyles, Tooltip, Typography } from '~/lib/bn-material-ui';
import { useChangeSelectedKey, useTranslationsEditContextSelector } from './translations-edit-context';

const useStyles = makeStyles(() => ({
  wrapperBox: {
    borderStyle: 'dashed',
    borderWidth: '1px',
    borderColor: 'red',
    padding: '1px 2px',
  },
  highlighted: {
    backgroundColor: 'red',
  },
  arrow: {
    color: 'white',
  },
  popper: {
    width: '320px',
    textWrap: 'wrap',
  },
  keyTitle: {
    fontWeight: 'bold',
  },
  keyName: {
    fontStyle: 'italic',
  },
  selectButton: {
    cursor: 'pointer',
    marginTop: '5px',
  },
}));

function TranslationTooltipContent({ translationKey }) {
  const styles = useStyles();
  const changeSelectedKey = useChangeSelectedKey();

  return (
    <div>
      <Typography className={styles.keyTitle}>Translation key: </Typography>
      <Typography className={styles.keyName}>{translationKey}</Typography>
      <Button
        className={styles.selectButton}
        variant='outlined'
        size='small'
        fullWidth
        onClick={(e) => {
          e.stopPropagation(); // stop the parent buttons from also triggering.
          changeSelectedKey(translationKey);
        }}
      >Select</Button>
    </div>
  );
}

// TODO - might actually need to memoize this, but let's wait and see.
export function TranslationEditModeTextWrapper({ translationKey, children }) {
  const styles = useStyles();
  const [highlightOn, selectedKey] = useTranslationsEditContextSelector(['highlightOn', 'selectedKey']);
  const isHighlighted = highlightOn && selectedKey === translationKey;

  const tooltipContent = TranslationTooltipContent({ translationKey });

  return (
    <Tooltip
      title={tooltipContent}
      arrow
      placement='top'
      classes={{ arrow: styles.arrow, popper: styles.popper }}
    >
      <span className={classNames(styles.wrapperBox, isHighlighted ? styles.highlighted : '')}>
        {children}
      </span>
    </Tooltip>
  );
}
